import * as React from 'react';

import { getConfig } from '@/features/environment/config';

const usePageHeadUpdater = () => {
  const isLeap = getConfig()?.CLIENT_NAME === 'lia-leap';
  React.useEffect(() => {
    // Update the document title
    const title = isLeap
      ? 'Livestock Entity Ag Platform'
      : 'Farm Credit Livestock Insurance Risk Analyzer';
    document.title = title;

    // Update the favicon
    const favicon = document.getElementById('favicon') as HTMLLinkElement | null;
    const faviconPath = isLeap ? '/favicon_leap.ico' : '/favicon.ico';
    favicon?.setAttribute('href', faviconPath);
  }, [isLeap]);
};

export default usePageHeadUpdater;
export { usePageHeadUpdater };
